module.exports = __webpack_public_path__ + "files/5c931dfcd6c0fd40787468221a4fceb9.png";